import page from './modules/page';
import dropdownModule from './modules/dropdown';
import search from './modules/search';
import mobile from './modules/mobile';
import filter from './modules/filter';
import header from './modules/header';
import video from './modules/video';
import initVideoModal from './modules/video-modal';
import carousel from './modules/carousel';
import gallery from './modules/gallery';
import homeBanner from './modules/home-banner';
// import heroCarousel from './modules/hero-carousel';
import scroll, { scrollToTarget } from './modules/scroll';
import { sidebarMod } from './modules/sidebar';
import initGlobalPopup from './modules/popup';

page();
dropdownModule.init();
mobile.init();
filter();
header();
video();
initVideoModal();
carousel();
gallery();
homeBanner();
search.init();
scroll();
initGlobalPopup();

// if tab key is used, add class to show outline styles
function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');
    window.removeEventListener('keydown', handleFirstTab);
  }
}

window.addEventListener('keydown', handleFirstTab);

window.addEventListener('load', (e) => {
  // heroCarousel();
  sidebarMod.check();

  if (window.location.hash) {
    const matching = document.getElementById(decodeURIComponent(window.location.hash.slice(1)))

    if (matching) {
      scrollToTarget(matching)
    }
  }

	document.body.classList.add('loaded')
})
